import { ISectionSpec } from 'components/SectionHeader'
import ReportsLayout from 'layouts/ReportsLayout'

export const MEETINGS: ISectionSpec = {
  basePath: 'meetings',
  baseTitle: '',
  sections: [
    {
      showDatePicker: true,
      path: () => '/',
      title: () => 'Meetings',
      component: ReportsLayout,
    },
  ],
}
